import { createSlice } from "@reduxjs/toolkit";

export const componentStateSlice = createSlice({
    name: "componentState",
    initialState: {
        floatingContainerState: false,
        floatingWindowState: false,
        quitConfirmationContainerState: false,
        headerState: false,
        sendMessageContainerState: false,
        isTypingContainerState: false,
    },
    reducers: {
        setFloatingContainerState: (state, action) => {
            state.floatingContainerState = action.payload;
        },
        setFloatingWindowState: (state, action) => {
            state.floatingWindowState = action.payload;
        },
        setQuitConfirmationState: (state, action) => {
            state.quitConfirmationContainerState = action.payload;
        },
        setHeaderState: (state, action) => {
            state.headerState = action.payload;
        },
        setSendMessageContainerState: (state, action) => {
            state.sendMessageContainerState = action.payload;
        },
        setIsTypingContainerState: (state, action) => {
            state.isTypingContainerState = action.payload;
        },
    }
});

export const { setFloatingContainerState, setFloatingWindowState, setQuitConfirmationState, setHeaderState, setSendMessageContainerState, setIsTypingContainerState } = componentStateSlice.actions;

export default componentStateSlice.reducer;
